import { oneOf } from 'prop-types'

export default oneOf(['idle', 'pending', 'succeed', 'failed'])